import { render, staticRenderFns } from "./DoKoViewLastTrick.vue?vue&type=template&id=7558b3b0&"
import script from "./DoKoViewLastTrick.vue?vue&type=script&lang=ts&"
export * from "./DoKoViewLastTrick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports